import type { Span } from "@opentelemetry/api";
import { context, trace } from "@opentelemetry/api";

export function getSpanContext(span: Span) {
    return trace.setSpan(context.active(), span);
}
